<s1-input-select [control]="control" [itemsList]="roles" [label]="label" [grouped]="grouped" [readonly]="readonly"></s1-input-select>